var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "swiper-container",
    on: {
      "mouseenter": _vm.mouseEnter,
      "mouseleave": _vm.mouseLeave
    }
  }, [_c('swiper', {
    attrs: {
      "options": _vm.swiperOptions
    }
  }, _vm._l(_vm.slides, function (item, index) {
    return _c('swiper-slide', {
      key: index
    }, [_c('div', {
      staticClass: "flexs margin-l-150 margin-t-100 max-w-600 relative"
    }, [_c('div', {
      staticClass: "flexs column text-l margin-t-50 margin-l-50 z-6"
    }, [_c('div', {
      staticClass: "flexs column"
    }, [_c('span', {
      staticClass: "fs-30 margin-b-10 f-700"
    }, [_vm._v(_vm._s(item.name))]), _c('span', {
      staticClass: "fs-18 c-6"
    }, [_vm._v(_vm._s(item.content))])]), _c('div', {
      staticClass: "flexs column margin-t-100"
    }, [_c('span', {
      staticClass: "fs-32 c-2E6AFA f-700"
    }, [_vm._v(_vm._s(item.addper))]), _c('span', {
      staticClass: "fs-18 c-6"
    }, [_vm._v("收益增加")])])]), _c('img', {
      staticClass: "absolute t-0 l-0",
      staticStyle: {
        "width": "105px",
        "height": "85px"
      },
      attrs: {
        "src": require("../../assets/images/class-icon.png")
      }
    })]), _c('img', {
      staticClass: "absolute t-0 l-0 z-01",
      staticStyle: {
        "width": "100%",
        "height": "600px"
      },
      attrs: {
        "src": _vm.getImagePath(index)
      }
    })]);
  }), 1), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isHover,
      expression: "isHover"
    }]
  }, [_c('div', {
    staticClass: "swiper-button-prev"
  }), _c('div', {
    staticClass: "swiper-button-next"
  })])], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };